(function (window) {
  'use strict';

  const tooltipOpenClass = 'js-tooltip--open';

  // Show or hide an existing tooltip
  function handleTooltip(ev) {
    ev.preventDefault();
    const openEvents = ['focus', 'mouseover'];
    const closeEvents = ['focusout', 'mouseout'];
    const tooltip = this.parentNode.querySelector('.tooltip');

    if (openEvents.includes(ev.type) && !!tooltip) {
      tooltip.classList.add(tooltipOpenClass);
      document.body.addEventListener('keydown', escKeyActions);
    } else if (closeEvents.includes(ev.type) && !!tooltip) {
      tooltip.classList.remove(tooltipOpenClass);
      document.body.removeEventListener('keydown', escKeyActions);
    }
  }

  function escKeyActions(event) {
    // Using event.key, because event.keyCode has been deprecated.
    // It is being used as a fallback.
    const key = event.key || event.keyCode;
    const tooltip = document.querySelector('.js-tooltip--open');

    // Use Escape key to close it.
    if(tooltip != null && (key === 'Escape' || key === 'Esc' || key === 27)) {
      tooltip.classList.remove(tooltipOpenClass);
    }
  }

  function init() {
    const tooltipLinks = document.querySelectorAll('.js-tooltip-open-link:not([data-tooltip-init])');
    for (let i = 0; i < tooltipLinks.length; i++) {
      tooltipLinks[i].addEventListener('mouseover', handleTooltip);
      tooltipLinks[i].addEventListener('focus', handleTooltip);
      tooltipLinks[i].addEventListener('mouseout', handleTooltip);
      tooltipLinks[i].addEventListener('focusout', handleTooltip);
      tooltipLinks[i].dataset.tooltipInit = 'true';
    }

    componentEvents.on('tooltip-build', buildTooltip);
    componentEvents.on('tooltip-destroy', destroyTooltip);
  }

  // Teardown mouse/focus events for existing tooltips
  function teardown(data) {
    const tooltipLink = data.tooltipLink;
    if (!tooltipLink) return;
    tooltipLink.removeEventListener('mouseover', handleTooltip);
    tooltipLink.removeEventListener('focus', handleTooltip);
    tooltipLink.removeEventListener('mouseout', handleTooltip);
    tooltipLink.removeEventListener('focusout', handleTooltip);
    delete tooltipLink.dataset.tooltipInit;
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  componentEvents.on('component-init', init);
  componentEvents.on('component-destroy', teardown);

  // Option to build a tooltip on the fly if one does not exist in the markup.
  function buildTooltip({ tooltipParent, tooltipModifiers, tooltipText, tooltipIcon }) {

    // Exit if we can't find the parent item to attach the tooltip to.
    if (!tooltipParent) return;

    // Create the container element for the tooltip.
    const container = document.createElement('DIV');
    container.id = `tooltip-${tooltipParent.id}`;
    container.classList.add('tooltip', tooltipModifiers);
    container.setAttribute('role', 'tooltip');

    // Option to add an icon
    if (tooltipIcon) {
      const icon = document.createElement('DIV');
      icon.classList.add('tooltip__icon');
      icon.innerHTML = '<svg class="icon icon--pdp-i-icon" alt=""><use xlink:href="/assets/icons/icons.svg#pdp-i-icon"></use></svg>';
      container.appendChild(icon);
    }

    // Add the text of the tooltip. If no text is provided, generic default text
    // will be used.
    const text = document.createTextNode(tooltipText || 'Not available with the current selection.');
    container.appendChild(text);

    // Append the newly-created tooltip to the parent item
    tooltipParent.appendChild(container);

    // Allow the tooltip parent to trigger show/hide of the tooltip
    tooltipParent.classList.add('js-tooltip-open-link');

    componentEvents.emitEvent('component-init');
  }

  // Remove a tooltip that was created with buildTooltip()
  function destroyTooltip(tooltipParent) {

    // Exit if there's no tooltip to remove.
    if (!tooltipParent) return;

    // Find the tooltip container within the parent and remove it.
    const container = tooltipParent.querySelector('.tooltip');
    if (container) {
      tooltipParent.removeChild(container);
    }

    // Remove the trigger from the parent that allows the tooltip to show/hide
    tooltipParent.classList.remove('js-tooltip-open-link');

    componentEvents.emitEvent('component-destroy', [{ tooltipLink: tooltipParent }]);
  }

  init();

})(this);
